import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ShareDialog from './ShareDialog';
import {faLink, faPencil, faObjectsColumn} from '@fortawesome/pro-light-svg-icons';

export default function StudentMenu({anchorEl, isMenuOpen, toggleMenu, student, isEditVisible = false}) {
  const [isShareDialogOpen, toggleShareDialog] = useState(false);
  const history = useHistory();

  const {id: studentID, authCode: studentAuthCode} = student || {};
  const shareURL = `${window.location.origin}/student/dashboard?authCode=${studentAuthCode}`;

  function handleClickStudentDashboard() {
    toggleMenu(false);
    history.push(`/student/dashboard?authCode=${studentAuthCode}`);
  }
  
  function handleEditStudent() {
    toggleMenu(false);
    history.push(`/builder/student/${studentID}`);
  }

  function handleClickGetShareLink() {
    toggleMenu(false);
    toggleShareDialog(true);
  }

  return (
    <>
      <ShareDialog open={isShareDialogOpen} handleClose={() => toggleShareDialog(false)} shareURL={shareURL} />
      <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={() => toggleMenu(false)}>
        <MenuItem onClick={handleClickStudentDashboard}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faObjectsColumn} />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </MenuItem>

        <MenuItem onClick={handleClickGetShareLink}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faLink} />
          </ListItemIcon>
          <ListItemText primary="Get Link" />
        </MenuItem>

        {isEditVisible && (
          <MenuItem onClick={handleEditStudent}>
            <ListItemIcon>
              <FontAwesomeIcon icon={faPencil} />
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
